import ContractsFilter from './ContractsFilter'

export default ContractsFilter
